import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";

const Navigation = () => {
	const [navclass, setNavClass] = useState("collapse navbar-collapse ");
	const [navactive, setNavActive] = useState(false);

	const togglenavbar = () => {
		// eslint-disable-next-line no-unused-vars
		setNavActive((pre) => (navactive ? false : true));

		setNavClass(
			navactive ? "collapse navbar-collapse " : "collapse navbar-collapse show "
		);
	};
	return (
		<nav className="navbar navbar-expand-lg navbar-light bg-dark">
			<NavLink
				className="navbar-brand ml-5 text-white"
				to="/"
				style={{ fontSize: "40px" }}
			>
        FA
			</NavLink>
			<button
				onClick={togglenavbar}
				className="navbar-toggler "
				type="button"
				data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation"
			>
				<GiHamburgerMenu style={{ color: "white" }} />
			</button>

			<div className={navclass} id="navbarSupportedContent">
				<ul className="navbar-nav ml-auto">
					<li className="nav-item active">
						<NavLink className="nav-link ml-5 text-white" to="/">
              Home
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link ml-5 text-white" to="/aboutme">
              About me
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link ml-5 text-white" to="/projects">
              Projects
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link ml-5 text-white" to="/blogs">
              Blogs
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link ml-5 text-white" to="/contact">
              Contact me
						</NavLink>
					</li>
					<li className="nav-item">
						<a
							className="btn btn-success nav-link ml-5 text-white"
							href="https://drive.google.com/file/d/1UxetSrP_dUtVMZiVMTS2vDuzZJNtfyM5/view?usp=sharing"
							target="__blank"
						>
              Resume
						</a>
					</li>
				</ul>
			</div>
		</nav>
	);
};

export default Navigation;
